import { render, staticRenderFns } from "./PCardListItem.vue?vue&type=template&id=1593828e&scoped=true&"
import script from "./PCardListItem.vue?vue&type=script&lang=ts&"
export * from "./PCardListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PCardListItem.vue?vue&type=style&index=0&id=1593828e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1593828e",
  null
  
)

export default component.exports